import React, { FC, useCallback, useContext, useMemo, useState } from 'react';

import ICONS from '../../../../../../constants/icons';
import { ButtonPopupType } from './constants';

import { EditorContext } from '../../../../../../context/EditorContext';

import confirm from '../../../../../../helpers/confirm';

import useFormulaButtonsDeleteMutation from '../../../../../../hooks/formula-buttons/useFormulaButtonDeleteMutation';
import useQueryFormulaButtons from '../../../../../../hooks/formula-buttons/useQueryFetchFormulaButtons';
import useOutsideClickDetector from '../../../../../../hooks/useOutsideClickDetector';

import FormulaEditorToolbarIcon from '../FormulaEditorToolbarIcon';
import NotificationButtonEditOrDeletePopUp from './NotificationButtonEditOrDeletePopUp';
import NotificationButtonModal from './NotificationButtonModal';

const NotificationButtonMain: FC = () => {
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    const { data: formulaButtons } = useQueryFormulaButtons(formula?.id!);
    const deleteButton = useFormulaButtonsDeleteMutation(formula?.id!);

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);

    const isDisabled = useMemo<boolean>(() => {
        return !formula?.id;
    }, [formula]);

    const handleDeleteClick = useCallback(async () => {
        const confirmed = await confirm(
            'Are you sure you want to delete the buttons? Messages will be sent without buttons',
            'warning',
            undefined,
            undefined,
            'Continue',
        );
        if (confirmed) {
            deleteButton.mutate();
        }
    }, [deleteButton]);

    const handleClick = (type: ButtonPopupType) => {
        if (type === ButtonPopupType.EDIT) {
            setIsModalOpen(true);
        } else {
            handleDeleteClick();
        }
        setIsPopupVisible(false);
    };

    const handleIconClick = () => {
        if (formulaButtons?.length) {
            setIsPopupVisible(true);
        } else {
            setIsModalOpen(true);
        }
    };

    const addButtonRef = useOutsideClickDetector(() =>
        setIsPopupVisible(false),
    );

    return (
        <>
            <div ref={addButtonRef}>
                <FormulaEditorToolbarIcon
                    isDisabled={isDisabled}
                    Icon={ICONS.addButton}
                    title="Add button"
                    showDot={!!formulaButtons?.length}
                    onIconClick={handleIconClick}
                />

                {!!formulaButtons?.length && isPopupVisible && (
                    <NotificationButtonEditOrDeletePopUp
                        handleClick={handleClick}
                    />
                )}
            </div>

            {isModalOpen && (
                <NotificationButtonModal
                    handleClose={() => setIsModalOpen(false)}
                    data={formulaButtons}
                />
            )}
        </>
    );
};

export default NotificationButtonMain;
